import {UserModel} from './user.model';

export class AuthorModel {
    id?: number;
    name: string;
    surname: string;
    title: string;
    titleAfter: string;
    login: string;

    static createFromUserModel(user: UserModel): AuthorModel {
        const author = new AuthorModel();
        author.login = user.login;
        author.surname = user.surname;
        author.name = user.name;
        author.title = user.title;
        author.titleAfter = user.titleAfter;
        return author;
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/models/author.model.ts